import { CropImageField } from './CropImageField'
import { withCropImageField } from './withCropImageField'

const ConnectedCropImageField = withCropImageField(CropImageField)

export { ConnectedCropImageField as CropImageField }
